// generic-client
import { formatDistanceToNow } from 'date-fns';
import type { Locale as DateFnsLocale, FormatDistanceFn } from 'date-fns';

type LocaleOverrides = {
  lessThanXMinutes: string;
  xSeconds: string;
  xMinutes: string;
  xHours: string;
  aboutXHours: string;
  xDays: string;
  xMonths: string;
  aboutXMonths: string;
  aboutXYears: string;
  overXYears: string;
  almostXYears: string;
};

export default (date: Date) => {
  const localeOverrides: LocaleOverrides = {
    lessThanXMinutes: '<{{count}}m',
    xSeconds: '{{count}}s',
    xMinutes: '{{count}}m',
    xHours: '{{count}}h',
    aboutXHours: '{{count}}h',
    xDays: '{{count}}d',
    xMonths: '{{count}}M',
    aboutXMonths: '{{count}}M',
    aboutXYears: '{{count}}Y',
    overXYears: '{{count}}Y',
    almostXYears: '{{count}}Y',
  };

  const formatDistance: FormatDistanceFn = (token, count) => {
    const template = localeOverrides[token as keyof LocaleOverrides];

    if (!template) return '';

    return template.replace('{{count}}', String(count));
  };

  const locale: Pick<DateFnsLocale, 'formatDistance'> = {
    formatDistance,
  };

  return formatDistanceToNow(date, {
    locale,
    includeSeconds: false,
  });
};
